import React, { Component } from 'react';
import styled from 'styled-components';


export const LabelVerificator = styled.label`
    color: ${props => props.danger ? '#db2828' : 'white'} !important;
    font-weight: 700;
    margin: 0 0 .28571429rem 0 !important;
`;